import z from 'zod';
import { markierungTypes } from '@/domain/termine/shared/types/Markierung';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { terminWiederholungValues } from '@/domain/termine/shared/types';
import dayjs from 'dayjs';

export function FormValidationSchema() {
  const { t } = useTranslation();

  const terminImage = z.object({
    image: z.object({
      name: z.string(),
      contentType: z.string(),
      url: z.string().url(),
      thumbnailUrl: z.string(),
      file: z.instanceof(File).optional(),
    }),
    markierung: z.enum(markierungTypes),
    expandable: z.boolean(),
  });

  const validation = useMemo(() => {
    const regExDateTime = /^([01]\d|2[0-3]):([0-5]\d)$/;

    return z
      .object({
        titel: z.string().min(1, t('domain.termine.sheet.validation.titel')),
        datum: z.string(),
        markierung: z.enum(markierungTypes).optional(),
        beginn: z
          .string()
          .optional()
          .refine((val) => !val || regExDateTime.test(val)),
        ende: z
          .string()
          .optional()
          .refine((val) => !val || regExDateTime.test(val)),
        beschreibung: z.string().optional(),
        specials: z.string().optional(),
        wiederholung: z.enum(terminWiederholungValues).optional(),
        wiederholungBis: z.string().optional(),
        terminImage: terminImage.optional(),
        terminKalenderId: z.string().optional(),
      })
      .refine(
        (data) => {
          if (!data.wiederholungBis) return true;
          const bis = dayjs(data.wiederholungBis).toDate();
          const datum = dayjs(data.datum).toDate();
          return bis >= datum;
        },
        {
          message: t('domain.termine.sheet.validation.laufzeit'),
          path: ['wiederholungBis'],
        },
      );
  }, [t, terminImage]);
  return validation;
}
